import React from 'react';
import coverbackground from '../../assets/fireb.jpg';
import ReusableMetricCard from '../../components/ReusableMetriccard/ReusableMetriccard';
import Up from '../../assets/up.png';

class ScrollWildfires extends React.Component {
  render () { 
   return(
  
  <ReusableMetricCard             
    
        description="Wildfires"
        trend={Up}
        metriclg="7 million"
        metricsm="acres burned per year"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollWildfires;